import type { DateRange, DefaultTDate } from '@branchjs/neo-components';
import { subDays } from 'date-fns';

/**
 * Generates a date range from today going back a specified number of days.
 * @param {number} daysBack - The number of days to subtract from the current date to determine the start date.
 * @return {DateRange<DefaultTDate>} - An array containing the start and end dates of the range.
 */
export const generateDateRange = (daysBack: number): DateRange<DefaultTDate> => {
  const today = new Date();
  const startDate = subDays(today, daysBack);

  return [startDate, today];
};
